module.exports = require("./hsb-DE");